export class ContactRepository {

    static getAll() {
        return JSON.parse(localStorage.getItem("contacts"));
    }

    static find(id) {
        const all = this.getAll();
        if (!all) return null;

        return all.find(item => item.id === id) || null;
    }


    static findByChatId(chatId) {
        const all = this.getAll();
        if (!all) return null;

        return all.find(item => parseInt(item.chat_id) === parseInt(chatId)) || null;
    }


    static deleteAll() {
        return localStorage.removeItem("contacts")
    }

    static saveContacts(contacts) {
        localStorage.setItem("contacts", JSON.stringify(contacts))
    }
}
